import { ViewportProps } from './viewport-props';
import { Platform } from './platform';

export interface PlatformApi {
  platform: Platform;
  /**
   * True when running on a mobile Discord client. Sourced from the Discord SDK's
   * `platform` ('mobile' | 'desktop'), which is parsed by the SDK constructor and
   * is available without awaiting `discordSdk.ready()`. Web is always false.
   */
  isMobile: boolean;
  initialize(): void;
}

export interface Fullscreenable extends PlatformApi {
  enterFullscreen(): Promise<ViewportProps>;
}

export interface Closeable extends PlatformApi {
  close(): Promise<void>;
}

export function isFullscreenable(platform: PlatformApi): platform is Fullscreenable {
  return typeof (platform as Fullscreenable).enterFullscreen === 'function';
}

export function isCloseable(platform: PlatformApi): platform is Closeable {
  return typeof (platform as Closeable).close === 'function';
}
